import { render, staticRenderFns } from "./ziyuan129.vue?vue&type=template&id=e2aed346&"
import script from "./ziyuan129.vue?vue&type=script&lang=js&"
export * from "./ziyuan129.vue?vue&type=script&lang=js&"
import style0 from "./ziyuan129.vue?vue&type=style&index=0&id=e2aed346&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports